<template>
  <div class="header__account-item header__account--basket">
    <a class="h-link"
       :href="link">
      <span v-if="count > 0">{{ count }}</span>
    </a>
    <div v-if="count > 0"
         class="h-basket">
      <div class="h-basket__top">
        <div class="h-basket__top-title">В корзине:</div>
        <div class="h-basket__top-count">{{ count }} {{ validText }}</div>
      </div>
      <div class="h-basket__list">
        <div class="b-list">
          <a v-for="item in moduleBasket.basket"
             :key="item.bid"
             class="b-list__item"
             :href="item.DETAIL_PAGE_URL">
            <div class="b-list__img"
                 :class="{'filled':item.PREVIEW_PICTURE}">
              <img :alt="item.NAME ? item.NAME : 'Изображение'"
                   :src="item.PREVIEW_PICTURE ? item.PREVIEW_PICTURE.src : ''"
                   loading="lazy">
            </div>
            <div class="b-list__right">
              <div class="b-list__title">{{ item.NAME }}</div>
              <div class="b-list__price">
                <div class="b-list__price-current">{{
                    new Intl.NumberFormat("ru-RU").format(Number(item.CURRENT_PRICE_EC).toFixed(0))
                  }}&nbsp;₽
                </div>
                <div v-if="item.DEFAULT_PRICE_EC > item.CURRENT_PRICE_EC"
                     class="b-list__price-old">{{
                    new Intl.NumberFormat("ru-RU").format(Number(item.DEFAULT_PRICE_EC).toFixed(0))
                  }}&nbsp;₽
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <a v-if="link"
         class="h-basket__link"
         :href="link">Перейти в корзину</a>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  name  : "MiniBasket",
  props : ["link"],
  data()
    {
      return {
        count     : 0,
        validText : "товар"
      };
    },
  watch    : {
    "moduleBasket.basket" : {
      handler()
        {
          this.count    =Object.keys(this.moduleBasket.basket).length;
          this.validText=this.textValidation();
        },
      deep : true
    }

  },
  computed : {
    ...mapState([
      "moduleBasket"
    ])
  },
  methods  : {
    ...mapActions([
      "GET_BASKET"
    ]),
    textValidation()
      {
        let len=Object.keys(this.moduleBasket.basket).length % 100;
        let val="";
        switch( true )
          {
            case len % 10 === 0:
            case len % 10 === 5 :
            case len % 10 === 6 :
            case len % 10 === 7 :
            case len % 10 === 8 :
            case len % 10 === 9:
            case ( len > 9 && len < 20 ):
              val=" товаров";
              break;
            case len % 10 === 2 :
            case len % 10 === 3 :
            case len % 10 === 4:
              val=" товара";
              break;
            case ( len % 10 === 1 ):
              val=" товар";
              break;
            default:
              val=" товар";
              break;
          }
        return val;
      }
  },
  created()
    {
      this.GET_BASKET();
    }
};
</script>

<style scoped>

</style>